var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adminpanel"},[_c('b-row',[_c('b-col',[_c('global-settings')],1)],1),_c('spacer-card'),_c('b-row',[_c('b-col',[_c('project-settings')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }